import React from "react";
import { toast } from "sonner";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useGetQuietHoursPolicyQuery, useUpdateQuietHoursPolicyMutation } from "@/store/rest_api";
import { apiErrorMessage } from "@/util/apiError";

export default function CallingHoursCard() {
  const { data: setting, isLoading } = useGetQuietHoursPolicyQuery();
  const [updatePolicy, { isLoading: isSaving }] = useUpdateQuietHoursPolicyMutation();
  const selectedOption = setting?.options.find((option) => option.name === setting.policy);

  async function handleChange(policy: string) {
    try {
      await updatePolicy({ policy }).unwrap();
      toast.success("Setting updated");
    } catch (error: unknown) {
      toast.error(apiErrorMessage(error, "Failed to update setting"));
    }
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Calling hours</CardTitle>
        <CardDescription>
          Calls and texts to leads follow their state's calling hours and daily call limits, including the power
          dialer, AI calls and workflow texts.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-row items-start justify-between gap-4 rounded-lg border p-4">
          <div className="space-y-1 pr-4">
            <p className="text-base font-medium">Outside calling hours</p>
            <p className="text-sm text-muted-foreground">{selectedOption?.description}</p>
          </div>
          <Select
            value={setting?.policy}
            onValueChange={(policy) => void handleChange(policy)}
            disabled={isLoading || isSaving}
          >
            <SelectTrigger className="w-48">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {setting?.options.map((option) => (
                <SelectItem key={option.name} value={option.name}>
                  {option.displayName}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  );
}
